import { useAuthContext } from '@contexts/authContext'
import { useNavigate, useSearchParams } from 'react-router-dom'
import styled from '@emotion/styled'
import { PiCaretLeftBold } from 'react-icons/pi'
import ScreenContainer from './ScreenContainer'
import { fontSize, size } from '@styles/theme'
import { Button } from '@mui/material'
import BackTopbar from '@elements/BackTopbar'
import SubscriptionConfirmation from '@components/billing/SubscriptionConfirmation'
import SubscriptionLanding from '@components/billing/SubscriptionLanding'
import usePaymentsApiContext from '@contexts/paymentsApiContext'
import { useEffect } from 'react'
import { BackgroundImage } from '@components/auth/landing/LandingElements'

const TopbarClearfix = styled.div`
  height: ${size(10)};
  flex-shrink: 0;
  width: 100%;
`

const Subscription = () => {
  const { state: authState } = useAuthContext()
  const isAnonymous = authState?.user?.isAnonymous
  const [searchParams] = useSearchParams()
  const step = searchParams.get('subscription_step') || '0'
  const { getPaymentsPromise, findOrCreateCustomer } = usePaymentsApiContext()

  useEffect(() => {
    if (isAnonymous) return;
    getPaymentsPromise()
      .then(() => findOrCreateCustomer())
      .catch(console.error)
  }, [isAnonymous])

  return(
    <ScreenContainer style={{ position: 'absolute', height: '100dvh', width: '100dvw' }}>
      <BackgroundImage src='https://mandrake-app.b-cdn.net/dev/application/display_elements/display-background-2-480w.jpeg' />
      <BackTopbar
        containerProps={{ style: { backgroundColor: 'black', border: 'none' } }}
        title={step == '1' ? 'Confirmation' : 'Supporter Plans'}
      />
      <TopbarClearfix style={{ height: size(7) }} />
      {step == '0' &&
        <SubscriptionLanding />
      }
      {step == '1' &&
        <SubscriptionConfirmation />
      }
    </ScreenContainer>
  )
}

export default Subscription
